import { __extends } from "tslib";
var ModuleError = /** @class */ (function (_super) {
    __extends(ModuleError, _super);
    function ModuleError(module, type) {
        var _this = this;
        var message;
        switch (type) {
            case 'Fetching_Error':
                message = "Error fetching ".concat(module, " module");
                break;
            case 'Initialization_Error':
                message = "Error initializing ".concat(module, " module");
                break;
            default:
                // If error is unknown it probably came within 1JS
                message = "Unknown error while fetching ".concat(module, " module");
        }
        _this = _super.call(this, message) || this;
        _this.type = 'Search_Module_Fetching_Error';
        _this.area = 'SearchResults';
        _this.name = "".concat(module, "_Error");
        return _this;
    }
    ModuleError.prototype.getType = function () {
        return this.type;
    };
    ModuleError.prototype.getArea = function () {
        return this.area;
    };
    return ModuleError;
}(Error));
export { ModuleError };
//# sourceMappingURL=ModuleError.js.map